import { Helmet } from "react-helmet-async";
import { useInView } from "../../../hooks/useInView";
import { useParallax } from "../../../hooks/useParallax";

function ParallaxHero({
  image,
  children,
  className = "relative h-[450px] flex items-center overflow-hidden bg-[#071A2F]",
  overlayClassName = "absolute inset-0 z-[1] bg-[#071A2F]/85 pointer-events-none",
  parallax = true,
  priority = true,
  rootMargin = "200px",
  imagePosition = "center",
}) {
  const [sectionRef, isInView] = useInView({ enabled: !priority, rootMargin });
  const parallaxRef = useParallax(0.12, parallax, imagePosition);
  const shouldLoadImage = priority || isInView;

  return (
    <section ref={sectionRef} className={className}>
      {priority && image && (
        <Helmet>
          <link rel="preload" as="image" href={image} />
        </Helmet>
      )}
      <div className="absolute inset-0 z-0 overflow-hidden" aria-hidden="true">
        <div
          ref={parallaxRef}
          className="absolute inset-0 bg-cover bg-no-repeat will-change-[background-position]"
          style={{
            backgroundImage:
              shouldLoadImage && image ? `url('${image}')` : undefined,
            backgroundPosition: imagePosition,
          }}
        />
      </div>

      <div className={overlayClassName} aria-hidden="true" />

      <div className="relative z-10 flex h-full w-full items-center">{children}</div>
    </section>
  );
}

export default ParallaxHero;
